import { HeaderConnected } from '@/components/HeaderConnected/HeaderConnected';
import { HeaderNotConnected } from '@/components/HeaderNotConnected/HeaderNotConnected';
import { useAuth } from '@/hooks/useAuth';

export const TopHeader: React.FC = () => {
  const { user } = useAuth();

  return user ? <HeaderConnected /> : <HeaderNotConnected />;
};
